import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  version: "1.1",
  viewBox: "0 0 16 16"
};
const _hoisted_2 = /*#__PURE__*/_createElementVNode("defs", null, [/*#__PURE__*/_createElementVNode("linearGradient", {
  id: "chatbot-linear-gradient"
}, [/*#__PURE__*/_createElementVNode("stop", {
  "stop-color": "#e80033",
  offset: "0%"
}), /*#__PURE__*/_createElementVNode("stop", {
  "stop-color": "#febb12",
  offset: "100%"
})])], -1);
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "url(#chatbot-linear-gradient)",
  d: "M8,1.49C4.08,1.49.9,4.05.9,7.2c0,1.5.72,2.85,1.89,3.87l-1.15,3.32c-.03.07.05.14.12.1l3.5-2.03c.84.28,1.77.44,2.74.44,3.92,0,7.1-2.56,7.1-5.71S11.92,1.49,8,1.49Z"
}, null, -1);
const _hoisted_4 = ["textLength", "lengthAdjust"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, [_hoisted_2, _hoisted_3, _createElementVNode("text", {
    "text-anchor": "middle",
    "alignment-baseline": "central",
    x: "8",
    y: "7.25",
    "font-size": "3.8",
    textLength: $options.hasLongLabel ? 12 : null,
    lengthAdjust: $options.hasLongLabel ? 'spacingAndGlyphs' : null
  }, _toDisplayString($options.getLabel('chatbot.chat')), 9, _hoisted_4)]);
}